import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TeamMemberViewProjectsComponent } from './projects-list/view-projects.component';
import { BBChartsModule } from '../../../shared/charts/bb-charts.module';
import { PipesModule } from '../../../shared/pipes/pipes-module.module';
import { RouterModule } from '@angular/router';
import { AddPurchasersComponent } from './add-purchasers/add-purchasers.component';

@NgModule({
  imports: [
    CommonModule,
    BBChartsModule,
    PipesModule,
    RouterModule
  ],
  declarations: [
    TeamMemberViewProjectsComponent
  ],
  exports: [
    TeamMemberViewProjectsComponent
  ]
})
export class ProjectComponentsModule { }



// WEBPACK FOOTER //
// ./client/app/features/projects/components/project-components.module.ts